import { Component, inject, OnDestroy, OnInit, signal } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { DataService } from "src/app/data.service";
import { NewMaterialDialogComponent } from "src/app/dialogs/material-dialog/material-dialog.component";
import { NewProductDialogComponent } from "src/app/dialogs/product-dialog/product-dialog.component";
import { HttpClient } from "@angular/common/http";
import { IApiResult } from "../../shared/models/apiresult.interface";
import { NewCustomerDialogComponent } from "src/app/dialogs/customer-dialog/customer-dialog.component";
import { NewFormulaDialogComponent } from "src/app/dialogs/formula-dialog/formula-dialog.component";
import { db } from "src/app/db.service";
import {
  Observable,
  map,
  Subject,
  tap,
  of,
  defer,
  merge,
  switchMap,
} from "rxjs";
import { ConfirmationDialogComponent } from "src/app/shared/confirmation-dialog/confirmation-dialog.component";
import { Router } from "@angular/router";

@Component({
  selector: "app-material",
  templateUrl: "./dev.component.html",
  styleUrls: ["./dev.component.css"],
})
export class DevComponent implements OnDestroy, OnInit {
  dataLoading = signal(false);
  router = inject(Router);
  performance: number = 0;
  navButtons = [
    {
      name: "Silinmələr",
      icon: "contract_delete",
      function: () => this.router.navigate(["/Deletions"]),
    },
    { name: "Push", icon: "transition_push", function: () => this.push() },
    {
      name: "Throw Error",
      icon: "error",
      function: () => this.triggerError(),
    },
    { name: "Clear Errors", icon: "save", function: () => this.clearErrors() },
  ];
  navExtraButtons = [
    {
      name: "Yeni Xammal",
      icon: "save",
      function: () => this.newMaterialDialog(event),
    },
    {
      name: "Yeni Məhsul",
      icon: "save",
      function: () => this.newProductDialog(event),
    },
    {
      name: "Yeni Müştəri",
      icon: "save",
      function: () => this.newCustomerDialog(event),
    },
    {
      name: "Yeni Formul",
      icon: "save",
      function: () => this.newFormulaDialog(event),
    },
  ];
  errors$: Observable<any[]>;
  fullErrorList = [];
  componentDestroyed$: Subject<boolean> = new Subject();
  status: any;

  checked = true;

  constructor(
    public _dataService: DataService,
    public dialog: MatDialog,
    private http: HttpClient
  ) {}

  async ngOnInit() {
    this.errors$ = this.getData();
  }

  ngOnDestroy(): void {
    this.componentDestroyed$.next(true);
    this.componentDestroyed$.complete();
  }

  getData() {
    this.dataLoading.set(true);
    const localData = JSON.parse(localStorage.getItem("errors")) || [];
    const localObservable = defer(() => {
      return of(localData);
    });
    const liveQueryObservable = this.http
      .get<any>("https://tekoplast.az/hesabat/api/?errors")
      .pipe(
        map((records) => {
          this.fullErrorList = records;
          let result = records.sort(
            (a, b) => new Date(b.date).getTime() - new Date(a.date).getTime()
          );
          const messageCount = new Map();
          result = Array.from(new Set(result.map((a) => a.message))).map(
            (message) => {
              const duplicates = result.filter((a) => a.message === message);
              const count = duplicates.length;
              const uniqueObj = { ...duplicates[0], duplicateNumber: count };
              messageCount.set(message, count);
              return uniqueObj;
            }
          );
          return result;
        }),
        tap((res) => {
          this._dataService.setLS("errors", res);
          localStorage.setItem("errors", JSON.stringify(res));
          this.dataLoading.set(false);
        })
      );
    return merge(localObservable, liveQueryObservable);
  }

  push(error?: string) {
    this.http
      .get(
        "https://tekoplast.az/docktr/api/?getTokens&uid=1TgHpEOspfZmDhanm8m1XLgm29u1"
      )
      .pipe(
        switchMap((res) => {
          let tokens = res[0].fcmToken;
          let requestData = {
            tokens: JSON.stringify(tokens),
            title: "JJ Accounting Error",
            body: error || null,
            url: "https://jj.tekoplast.az",
          };
          return this.http.post(
            "https://tekoplast.az/docktr/api/?pushNotification",
            requestData
          );
        })
      )
      .subscribe();
  }

  triggerError() {
    const apiUrl = "https://tekoplast.az/hesabat/api/?error";

    const dummyError = {
      message: "This is a dummy error from Angular",
      stackTrace: "at AppComponent.postDummyError (app.component.ts:15)",
      transaction: "Angular Test",
      formData: "{}",
      data: "{}",
      date: new Date().toISOString().slice(0, 19).replace("T", " "),
      dbTable: "N/A",
      user: "dev_tester",
      appVersion: "0.0.1-test",
    };

    console.log("Sending dummy error to API:", dummyError);

    this.http.post(apiUrl, dummyError).subscribe({
      next: (response) => {
        console.log("✅ Success! API Response:", response);
        alert("API call successful! Check your database.");
      },
      error: (err) => {
        console.error("❌ Failure! API Error:", err);
        alert(
          "API call failed. Check browser console for CORS or other errors."
        );
      },
    });

    throw new Error("Test error for error handling");
  }

  clearErrors() {
    this.http
      .post(`https://tekoplast.az/hesabat/api/?clearErrors`, {})
      .subscribe(() => (this.errors$ = this.getData()));
  }

  deleteEntry(error) {
    let idsToDel;
    idsToDel = this.fullErrorList
      .filter((err) => err.message == error.message)
      .map((err) => err.id);

    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: "500px",
      data: error.message,
    });
    dialogRef.afterClosed().subscribe((res) => {
      if (res) {
        this.http
          .post("https://tekoplast.az/hesabat/api/?deleteErrors", {
            ids: idsToDel,
          })
          .subscribe(async () => {
            this.errors$ = this.getData();
          });
      }
    });
  }

  clearTable() {
    db.transactions.clear();
    db.bank.clear();
    db.sells.clear();
    db.stock.clear();
    db.production.clear();
    // db.transactionDeletions.clear();

    localStorage.removeItem(this._dataService.dbTable + "lastTransactionId");
    localStorage.removeItem(`${this._dataService.dbTable}lastBankId`);
    localStorage.removeItem(`${this._dataService.dbTable}lastSellId`);
    localStorage.removeItem(`${this._dataService.dbTable}lastStockId`);
    localStorage.removeItem(`${this._dataService.dbTable}lastProductionId`);
    localStorage.removeItem(
      `${this._dataService.dbTable}lastTransactionDeletion`
    );
    console.log("cleared");
  }

  newMaterialDialog(event?) {
    this.dialog.open(NewMaterialDialogComponent, {
      width: "520px",
    });
  }

  newProductDialog(event) {
    this.dialog.open(NewProductDialogComponent, {
      width: "900px",
      data: this._dataService.products().find((x) => x.id == 142),
    });
  }

  newCustomerDialog(event) {
    this.dialog.open(NewCustomerDialogComponent, {
      width: "500px",
      data: event,
    });
  }

  newFormulaDialog(event) {
    this.dialog.open(NewFormulaDialogComponent, {
      width: "800px",
      data: { formulaId: 27 },
      panelClass: "materialDialog",
    });
  }
}
